import React									from 'react';

import Checkbox									from './Checkbox';
import {CheckboxGroupProps}						from './interface';

import './CheckboxGroup.css';


function CheckboxGroup(props: CheckboxGroupProps) {
	function renderItems() {
		const render: React.ReactElement[] = [];

		props.data.forEach((data) => {
			render.push(
				<div
					data-center={!data.text}
					data-disabled={data.disabled}
					className={'checkboxGroupItem'}
					data-active={props.actual === data.value}
					onClick={() => !data.disabled && props.onChange(data.value)}
				>
					<Checkbox
						round
						readOnly={data.disabled}
						active={props.actual === data.value}
						onChange={() => !data.disabled && props.onChange(data.value)}
					/>
					<div className={'checkboxGroupItemText'}>
						<span>{data.title}</span>
						{data.text && <span className={'gray-600 weight-400'}>{data.text}</span>}
					</div>
				</div>
			);
		});

		return render;
	}

	return (
		<div className={'checkboxGroupContainer'}>
			{props.title &&
				<div className={'checkboxGroupTitle'}>
					<span className={'text-sm weight-500 gray-700'}>{props.title}</span>
					{props.afterTitle}
				</div>
			}

			{renderItems()}
		</div>
	);
}

export default CheckboxGroup;